import React, { Component } from 'react';
import intl from 'react-intl-universal';
import './index.less';
import Quantity from './quantity';
import Skeleton from './skeleton';
import { replaceData } from './datamanage/replaceData';
import { removeData } from './datamanage/removeData';
import { replaceSkuData } from './datamanage/replaceSkuData';
import { getCartList, getTotalPrice, checkStatus, removeItem, modifyQuantity, addToCart, getCartNum, submitCart } from '../service/index';
import { getCookie } from '../util/cookie';
import { getCheckedCookie, updateCheckedCookie } from '../util/setCheckedCookie';
import { arrReduce } from '../util/arrreduce';
import { errorLog } from '../util/errorlog';
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLogin: '',
            totalAmountUsd: 0,
            totalamountLocal: 'US $0.00',
            selectedItemCount: 0, //选中多少条
            selectedItems: [],
            cartList: [],
            disableList : [], //不可运达和sold out产品列表
            cartListLen: 0,
            disalbedLen: 0,
            showSkeleton: true,
            loading: false,
            cartMaxSize: '',
            expansionABV: ''
        }

        this.updateQuantity = this.updateQuantity.bind(this);
        this.submitCheckOut = this.submitCheckOut.bind(this);
        this.addToCartFn = this.addToCartFn.bind(this);

    }

    componentDidMount(){
        //获取cookie 判断登录状态
        this.setState({
            isLogin: getCookie('b2b_b_t_v2')
        })

        //add to cart
        this.addToCartFn();

        //获取列表信息
        window.getCartListData = ()=>this.getCartListData(0); //先定义下全局函数,以便外部调用
        this.getCartListData(1);
    }
    componentWillUnmount(){
        //解除监听
        this.removeEventListScroll();

        this.setState = (state, callback) => {
            return
        }
    }
    getCartListData(flushFlag){
        let flushCache = flushFlag === 1 ? 1 : '';
        let getCheckedItems = getCheckedCookie();
        let saveDisableList = [];
        let cartListLen = 0;
        let disalbedLen = 0;

        getCartList({ flushCache: flushCache, cartIds: getCheckedItems.join(',') || '' }, 'v2').then((res) => {
            let newCartList, allProductLen = 0;
            if (res.state === '0x0000') {
                newCartList = res.data.cartData || [];

                newCartList.forEach((store) => {
                    store.cartMixList.forEach((list) => {
                        let mixListLen = list.cartList.length;
                        let isMix = mixListLen > 1 ? true : false;

                        list.cartList.forEach((proList) => {
                            //统计所有产品个数
                            allProductLen++;

                            //不可运达或sold out,设置勾选框置灰
                            let { productInventory } = proList.product;
                            if (!proList.cartShip?.shipMethod || (!!productInventory.maxQuantity && productInventory.maxQuantity === 0) || !!productInventory.noSale) {
                                proList.isDisabled = true;
                                proList.isChecked = false;
                                proList.isMix = isMix;
                                saveDisableList.push(proList);
                                disalbedLen+=1;
                            } else {
                                proList.isDisabled = false;
                                cartListLen+=1;
                            }

                            //校验当前产品cartId在cookie中是否存在
                            if(getCheckedItems.length > 0){
                                var isIn = getCheckedItems.indexOf(proList.product.cartId);
                                if(isIn !== -1){
                                    //存在则选中
                                    if(!proList.isDisabled){
                                        proList.isChecked = true;
                                    }
                                }else{
                                    //不存在则不选中
                                    proList.isChecked = false;
                                }
                            }else{
                                proList.isChecked = false;
                            }
                        });
                    });
                });

                this.setState({
                    cartList: newCartList || [],
                    disableList: saveDisableList,
                    cartListLen: cartListLen,
                    disalbedLen: disalbedLen,
                    showSkeleton: false,
                    cartMaxSize: res.data.cartMaxSize || '',
                    expansionABV: '553_'+res.data.expansionVersion || ''
                }, () => {
                    //请求total价格接口
                    this.getTotalPriceData(newCartList, false);

                    //图片懒加载
                    if(this.state.cartList.length > 0 || this.state.disableList.length > 0){
                        this.checkImages();
                        this.addEventListScroll();
                    }

                    //购物车扩容分流埋点
                    //如果命中分流
                    if(flushFlag === 1 && !!res.data.expansionVersion){
                        this.trackCartInfo({
                            id: 'expansionTrack',
                            spmC: 'Diversionreporting',
                            eventCode: 'CMnzvmI8gBKe'
                        })
                    }
                });
            }else{
                this.setState({
                    showSkeleton: false
                });

                //发送错误日志
                errorLog('https://shoppingcart.dhgate.com/checkout/cartSplit/getCartxProductListInCart.do?client=pc&newCartMix=1', { flushCache: flushCache, cartIds: getCheckedItems.join(',') || '' }, res, 'express cart');
            }
        }).catch((err) => {});
    }
    getTotalPriceData(cartList){
        let cartIdArr = [], cartIds = '';
        let count = 0;
        let selectedItems = [];

        cartList.forEach((store) => {
            store.cartMixList.forEach((list) => {
                list.cartList.forEach((proList) => {
                    if (!!proList.isChecked) {
                        //获取选中产品的cartId
                        cartIdArr.push(proList.product.cartId);

                        // 计算勾选商品及数量
                        count++

                        //存储已选中的产品
                        selectedItems.push(proList);
                    }
                })
            })
        })

        cartIds = cartIdArr.join(',');

        // 更新价格的同时，统计商品个数
        this.setState({
            selectedItemCount: count,
            selectedItems: selectedItems
        })

        getTotalPrice({ cartId: cartIds }).then(res => {
            if (res.state === '0x0000') {
                this.setState({
                    totalAmountUsd: res.data.totalAmountUsd || 0,
                    totalamountLocal: res.data.totalamountLocal || '',
                });

                //隐藏loading蒙层
                this.onAllLoading(false);
            }else{
                //隐藏loading蒙层
                this.onAllLoading(false);
                //发送错误日志
                errorLog('https://shoppingcart.dhgate.com/checkout/cartSplit/getTotalPrice.do?client=pc', { cartId: cartIds }, res, 'express cart');
            }
        }).catch((err) => {
            //隐藏loading蒙层
            this.onAllLoading(false);
            return err;
        });
    }
    onCheck(isDisabled, isChecked, cartId, itemcode){
        if (!!isDisabled) {
            return
        }

        //改变loading状态
        this.onAllLoading(true);

        let cartList = JSON.parse(JSON.stringify(this.state.cartList));
        let checkItems = [], itemcodes = []; //传参
        let checkedItemsCookie = []; //用于重置已选中产品的cookie

        cartList.forEach((store)=>{
            store.cartMixList.forEach((list) => {
                //先循环一遍看是否有混批产品是勾选状态
                let mixCheckedLen = 0;
                if(list.cartList.length > 1){
                    list.cartList.forEach((proList)=>{
                        if(!!proList.isChecked){
                            mixCheckedLen++;
                        }
                    })
                }

                list.cartList.forEach((proList) => {
                    if(proList.product.cartId === cartId){
                        proList.isChecked = isChecked ? false : true;

                        this.getItemParams(proList, cartId, checkItems, itemcodes, 'check');
                    }else{

                        if(proList.product.productBase.itemcode === itemcode){
                            //如果itemcode与当前操作的产品相同，不管勾不勾选都取参
                            this.getItemParams(proList, cartId, checkItems, itemcodes, 'check');

                        }else{
                            //如果itemcode与当前操作的产品不同
                            if(mixCheckedLen > 0){
                                //如果混批里有选中的，取与之混批的所有产品信息
                                this.getItemParams(proList, cartId, checkItems, itemcodes, 'check');
                            }else{
                                //如果不是混批，取已勾选的产品信息
                                if(!!proList.isChecked){
                                    this.getItemParams(proList, cartId, checkItems, itemcodes, 'check');
                                }
                            }
                        }
                    }

                    if(!!proList.isChecked){
                        //获取勾选产品的信息
                        let proInfo = proList.product.cartId + '_' + proList.cart.skuId;
                        checkedItemsCookie.push(proInfo);
                    }
                })
            })
        })

        //重置已选中产品cookie
        updateCheckedCookie(checkedItemsCookie);

        //itemcode去重
        itemcodes = arrReduce(itemcodes);

        //设置传参
        let params = {
            itemcode: itemcodes.join(','),
            checkItems: JSON.stringify(checkItems)
        }

        //请求接口
        checkStatus(params, 'v2').then((res) => {
            if(res.state === '0x0000'){
                if(!!res.data.cartData){
                    //替换数据
                    let manageData = replaceData(cartList, res.data.cartData);

                    //更新state
                    this.setState({
                        cartList: manageData
                    }, () => {
                        //请求total接口
                        this.getTotalPriceData(manageData);
                    })
                }else{
                    this.setState({
                        cartList: cartList
                    }, () => {
                        //请求total接口
                        this.getTotalPriceData(cartList);
                    })
                }
            }else{
                this.setState({
                    cartList: cartList
                }, () => {
                    //请求total接口
                    this.getTotalPriceData(cartList);
                })

                //发送错误日志
                errorLog('https://shoppingcart.dhgate.com/checkout/cartSplit/checkCart.do?client=pc&newCartMix=1', params, res, 'express cart');
            }

        }).catch((err) => {
            this.setState({
                cartList: cartList
            }, () => {
                //请求total接口
                this.getTotalPriceData(cartList);
            });

            return err;
        });

    }
    onRemove(isChecked, cartId, itemcode, isMix){
        //改变loading状态
        this.onAllLoading(true);

        let getRequestParams = this.getParams(isChecked, cartId, itemcode, 'remove');
        let checkItems = JSON.stringify(getRequestParams.checkItems);
        let itemcodes = arrReduce(getRequestParams.itemcodes); //去重

        //设置参数
        let params = {
            cartId: cartId,
            itemcode: itemcodes.join(','),
            checkItems: checkItems,
            mixType: !!isChecked ? '1' : (isMix ? '1' : '2'),
            type: '1'
        };

        //请求remove接口
        removeItem(params, 'v2').then((res) => {
            if(res.state === '0x0000'){

                let cartList = JSON.parse(JSON.stringify(this.state.cartList));

                //在列表中删除当前产品
                let manageData = removeData(cartList, cartId);

                //替换数据
                if(!!res.data?.cartData && res.data?.cartData?.length > 0){
                    manageData = replaceData(manageData, res.data.cartData);
                }

                //更新state
                this.setState({
                    cartList: manageData
                }, () => {
                    //请求total接口
                    this.getTotalPriceData(manageData);
                    //图片懒加载
                    this.checkImages();
                })

                //更新头部购物车数量
                let miniCart = window.parent.document.getElementById('cartcnt');
                let miniCartNum = parseInt(miniCart.innerText);
                miniCart.innerText = miniCartNum-1;
            }else{
                //改变loading状态
                this.onAllLoading(false);
                //发送错误日志
                errorLog('https://shoppingcart.dhgate.com/checkout/cartSplit/newRemove.do?client=pc&newCartMix=1', params, res, 'express cart');
            }
        }).catch(err => {
            //改变loading状态
            this.onAllLoading(false);

            return err;
        });
    }
    //disalbe列表里用的remove
    onSampleRemove(cartId, isMix){

        //改变loading状态
        this.onAllLoading(true);

        //设置参数
        let params = {
            cartId: cartId,
            itemcode: '',
            checkItems: '[]',
            mixType: isMix ? '1' : '2',
            type: '1'
        };

        //请求remove接口
        removeItem(params, 'v2').then((res) => {
            if(res.state === '0x0000'){

                let copyDisableList = JSON.parse(JSON.stringify(this.state.disableList));
                let saveList = [];

                //在disable列表中删除当前产品
                copyDisableList.forEach((proList, proIndex)=>{
                    if(proList.product.cartId !== cartId){
                        saveList.push(proList);
                    }
                })

                //更新state
                this.setState({
                    disableList: saveList
                },()=>{
                    //图片懒加载
                    this.checkImages();
                })

                //更新头部购物车数量
                let miniCart = window.parent.document.getElementById('cartcnt');
                let miniCartNum = parseInt(miniCart.innerText);
                miniCart.innerText = miniCartNum-1;
            }else{
                //发送错误日志
                errorLog('https://shoppingcart.dhgate.com/checkout/cartSplit/newRemove.do?client=pc&newCartMix=1', params, res, 'express cart');
            }

            //改变loading状态
            this.onAllLoading(false);
        }).catch(err => {
            //改变loading状态
            this.onAllLoading(false);
            return err;
        });
    }
    updateQuantity(isChecked, supplierId, cartId, itemcode, quantity){
        //改变loading状态
        this.onAllLoading(true);

        let getRequestParams = this.getParams(isChecked, cartId, itemcode, 'quantity');
        let checkItems = JSON.stringify(getRequestParams.checkItems);
        let itemcodes = arrReduce(getRequestParams.itemcodes); //去重

        //设置参数
        let params = {
            cartId: cartId,
            quantity: quantity,
            itemcode: itemcodes.join(','),
            checkItems: checkItems
        }

        //请求接口
        modifyQuantity(params, 'v2').then((res) => {
            if(res.state === '0x0000' && !!res.data){

                let cartList = JSON.parse(JSON.stringify(this.state.cartList));

                let manageData = replaceSkuData(cartList, res.data.cartData, supplierId, itemcode);

                //更新state
                this.setState({
                    cartList: manageData
                }, () => {
                    //请求total接口
                    this.getTotalPriceData(manageData);
                })

            }else{
                //改变loading状态
                this.onAllLoading(false);
                //发送错误日志
                errorLog('https://shoppingcart.dhgate.com/checkout/cartSplit/updateQuantity.do?client=pc&newCartMix=1', params, res, 'express cart');
            }
        }).catch(err => {
            //改变loading状态
            this.onAllLoading(false);

            return err
        });
    }
    onAllLoading(loading) {
        this.setState({
            loading: loading
        })
    }
    getParams(isChecked, cartId, itemcode, optType){
        let { cartList, selectedItems } = this.state;

        let copyList = JSON.parse(JSON.stringify(cartList));

        //设置参数
        let params = {'checkItems': [], 'itemcodes': []};

        copyList.forEach((store)=>{
            store.cartMixList.forEach((list)=>{
                list.cartList.forEach((proList)=>{
                    if(!!isChecked){
                        //如果当前操作的产品已勾选，取其他已勾选及与已勾选的itemcode相同的产品
                        selectedItems.forEach((selectedProList)=>{
                            if(proList.product.productBase.itemcode === selectedProList.product.productBase.itemcode){
                                this.getItemParams(proList, cartId, params.checkItems, params.itemcodes, optType);
                            }
                        })
                    }else{
                        //如果当前操作的产品未勾选，取与当前操作的产品itemcode相同的产品信息
                        if(proList.product.productBase.itemcode === itemcode){
                            this.getItemParams(proList, cartId, params.checkItems, params.itemcodes, optType);
                        }
                    }
                })
            })
        })

        return params;

    }
    getItemParams(proList, cartId, checkItems, itemcodes, optType){
        if(optType === 'remove' && proList.product.cartId === cartId){
            return
        }

        let itemParam = {};

        itemParam.cartId = proList.product.cartId;
        itemParam.checkStatus = proList.isChecked;
        checkItems.push(itemParam);
        itemcodes.push(proList.product.productBase.itemcode);
    }
    submitCheckOut(){
        let cartList = JSON.parse(JSON.stringify(this.state.cartList));
        let {selectedItemCount} = this.state;
        let cartIdArr = [];

        //已勾选产品超过最大限制提示
        if(!!this.state.cartMaxSize && selectedItemCount > this.state.cartMaxSize){
            this.toastFn(intl.get('cart_checked_max_tip', {selectedNum: selectedItemCount}));
            // 埋点
            this.trackCartInfo({
              id: 'addToCartFailTip',
              spmC: 'hint',
              other: {"sku quantity": selectedItemCount || ""},
              eventCode: 'Q4uByo30K4iB',
            });

            return
        }

        this.onAllLoading(true);

        //获取参数
        //获取选中产品的cartId
        cartList.forEach((store) => {
            store.cartMixList.forEach((list) => {
                list.cartList.forEach((proList) => {
                    if (!!proList.isChecked) {
                        cartIdArr.push(proList.product.cartId);
                    }
                })
            })
        })

        let params = {
          cartIds: cartIdArr.join(','),
        }

        //请求接口
        submitCart(params).then((res)=>{
          if(res.state === '0x0000'){
            window.parent.location.href = '//shoppingcart.dhgate.com/placeorder';
          }else{
            //如果是0x0304，重调大接口
            if(res.state === '0x0304'){
              this.getCartListData(1);
            }

            //提示
            //0x0401 购物车商品不存在
            //0x0304 购物车为空
            //0x0402 黑名单-卖家把买家拉黑
            this.toastFn(
              res.state === '0x0401' || res.state === '0x0304'
              ? intl.get('checkout_error_not_exist')
              : res.state === '0x0402'
              ? intl.get('cart_label_not_accept_order', {sellerNames: res.data.join(',')})
              : intl.get('cart_net_error_tip')
            );

            // 埋点
            this.trackCartInfo({
              id: 'addToCartFailTip',
              spmC: 'checkout',
              other: {"error": res?.state || ""},
              eventCode: 'kf8i3N6NHo42',
            });
          }

          //设置loading状态
          this.onAllLoading(false);
        }).catch(()=>{

          //设置loading状态
          this.onAllLoading(false);
        })

    }
    goToCart(){
        window.parent.location.href = '//shoppingcart.dhgate.com/cart/list';
    }
    addEventListScroll(){
        //监听滚动，懒加载图片
        let cartList = document.getElementById('expressCartList');
        cartList.addEventListener('scroll', this.checkImages);
    }
    removeEventListScroll(){
        //解除监听
        let cartList = document.getElementById('expressCartList');
        cartList.removeEventListener('scroll', this.checkImages);
    }
    checkImages(){
        let isInClient = (item)=>{
            let offset = item.getBoundingClientRect();
            let bodyHeight = document.body.offsetHeight;
            if((offset.top > 0 && offset.top < bodyHeight) || (offset.bottom > 0 && offset.bottom < bodyHeight)){
                return true
            }else{
                return false
            }
        }

        let imgs = document.querySelectorAll('img');
        imgs.forEach((item, index)=>{
            let src = item.getAttribute('src');
            if(isInClient(item) && src === ''){
                item.setAttribute('src', item.getAttribute('data-src'));
                //设置a标签的一些样式
                setTimeout(()=>{
                    let wrapA = item.parentNode;
                    wrapA.style.height = 'auto';
                    wrapA.style.background = 'none';
                },50)

            }
        })


    }
    addToCartFn(){
        window.parent.document.addEventListener('click', (event)=>{
            let target = event.target;
            if(target.nodeName == 'SPAN' && target.getAttribute('addcart-flag') == 'true'){
                //获取产品图片
                let proImg = target.getAttribute('proImg') || '';
                let itemcode = target.getAttribute('itemcode') || '';

                //加购动画
                // if(window.parent.innerWidth >= 1140){
                //     let boundBtn = target.getBoundingClientRect();
                //     let scrollTop = window.parent.document.documentElement.scrollTop || window.parent.document.body.scrollTop || 0;
                //     let x = boundBtn.left + boundBtn.width / 2 - 15;
                //     let y = boundBtn.top + scrollTop - 30;
                //     this.createBall(x, y, proImg, itemcode);
                // }

                //设置参数
                let params = {
                    act: 'addtocart',
                    isblank: true,
                    itemcode: itemcode,
                    supplierId: target.getAttribute('supplierId') || '',
                    shipCountry:  getCookie('b2b_ship_country') || ''
                }

                addToCart(params).then((res) => {
                    if(!!res && res !== 'apiErr'){
                        if(res.isadded === 1){
                            //获取cart列表信息
                            // this.getCartListData(0);
                            //加购成功提示
                            this.toastFn(intl.get('cart_add_success_tip'));
                            //更新头部购物车数量
                            let numParams = {
                              buyerId: getCookie('b2b_buyerid') || '',
                              cartsid: getCookie('b2b_cart_sid') || '',
                            }
                            getCartNum(numParams).then((res)=>{
                                if(!!res && res !== 'apiErr' && res.state === '0x0000' && !!res.data){
                                    let miniCart = window.parent.document.getElementById('cartcnt');
                                    miniCart.innerText = res.data?.size || 0;
                                }
                            }).catch(err=>{return err;})

                            // let miniCart = window.parent.document.getElementById('cartcnt');
                            // let miniCartNum = parseInt(miniCart.innerText);
                            // miniCart.innerText = miniCartNum + 1;
                        }else if(res.isadded === 2){
                            //购物车已满提示
                            this.toastFn(intl.get('cart_max_num_tip'));
                        }else{
                            //加购失败提示
                            this.toastFn(intl.get('cart_add_fail_tip'));
                        }

                        //购物车扩容埋点
                        if(!!res.expansionVersion){
                            try {
                                let parentBody = window.parent.document.getElementsByTagName('body');
                                let parentSPMB = parentBody[0].getAttribute('spm-b') || '';
                                let addToCartFlag = window.parent.document.getElementById('loveAddToCart');
                                if(!addToCartFlag){
                                    let appendObj = window.parent.document.createElement('span');
                                    appendObj.setAttribute('id', 'loveAddToCart');
                                    appendObj.setAttribute('event-code', parentSPMB === 'sp' ? 'BMpn2obnv5TZ' : 'v30zoTk4hxuP');
                                    appendObj.setAttribute('ab-version', '553_'+res.expansionVersion);
                                    window.parent.document.body.appendChild(appendObj);
                                    addToCartFlag = window.parent.document.getElementById('loveAddToCart');
                                }

                                window.__exposureBuryingPoint.init({
                                    module: addToCartFlag,
                                    moduleName: 'addcart',
                                    spm_b: parentSPMB,
                                    moduleIndex: '1',
                                    event_body: {
                                        event_type: 'click',
                                        event_name: 'click',
                                        event_data: {
                                            event_entity_info: {
                                                link_type:'',
                                                other: "{'buyerid':'"+getCookie('b2b_buyerid')+"'}"
                                            }
                                        }
                                    }
                                });
                            }catch(error){}
                        }

                    }else{
                        //加购异常提示
                        this.toastFn(intl.get('cart_net_error_tip'));
                        //发送错误日志
                        errorLog('https://shoppingcart.dhgate.com/cart/addToCartForSearchJson.do', params, res, 'express cart');
                    }
                }).catch(err => {
                    return err
                });
            }
        })
    }
    createBall(x, y, proImg, itemcode){
        //绘制div
        let cartBall = window.parent.document.createElement('div');
        cartBall.setAttribute('id', 'cartBall'+itemcode);
        cartBall.style.position = 'absolute';
        cartBall.style.left = x + 'px';
        cartBall.style.top = y + 'px';
        cartBall.style.zIndex = '10';
        cartBall.style.width = '30px';
        cartBall.style.height = '30px';
        cartBall.style.border = '2px solid #666';
        cartBall.style.borderRadius = '50%';
        cartBall.style.backgroundColor = '#fff';
        cartBall.style.transition = 'left 0.8s linear, top 0.8s cubic-bezier(.01, .02, .17, .85)';
        //绘制产品图
        let imgBox = window.parent.document.createElement('img');
        imgBox.setAttribute('src', proImg);
        imgBox.style.width = '100%';
        imgBox.style.height = '100%';
        imgBox.style.borderRadius = '50%';
        //填充到页面
        cartBall.appendChild(imgBox);
        window.parent.document.body.appendChild(cartBall);

        setTimeout(()=>{
            //移动位置
            let rightCartWrap = window.parent.document.getElementById('rightExpressCart');
            let scrollTop = window.parent.document.documentElement.scrollTop || window.parent.document.body.scrollTop || 0;
            cartBall.style.left = (rightCartWrap.offsetLeft + 45) + 'px';
            cartBall.style.top = (scrollTop + rightCartWrap.offsetTop + 170) + 'px';
        }, 200)

        //动画结束后，删除自己
        setTimeout(()=>{
            // cartBall.ontransitionend = ()=>{
                let curBall = window.parent.document.getElementById('cartBall'+itemcode);
                window.parent.document.body.removeChild(curBall);
            // }
        }, 1050)
    }
    toastFn(message){
        let toastDom = window.parent.document.getElementById('addToCartFailTip');
        !!toastDom && window.parent.document.body.removeChild(toastDom);
        //绘制toast
        let toast = window.parent.document.createElement('div');
        toast.setAttribute('id', 'addToCartFailTip');
        toast.innerHTML = message;
        //设置样式
        toast.style.position = 'fixed';
        toast.style.left = '50%';
        toast.style.top = '50%';
        toast.style.zIndex = '9999';
        toast.style.padding = '15px';
        toast.style.minWidth = '300px';
        toast.style.maxWidth = '450px';
        toast.style.color = '#fff';
        toast.style.textAlign = 'center';
        toast.style.fontSize = '14px';
        toast.style.borderRadius = '6px';
        toast.style.background = 'rgba(0, 0, 0, 0.8)';
        toast.style.transform = 'translate(-50%, -50%)';

        window.parent.document.body.appendChild(toast);

        let toastTimer = setTimeout(()=>{
            window.parent.document.body.removeChild(toast);
            toastTimer = null;
        }, 3000);
    }
    siginFn(){
        // let siginBtn = window.parent.document.getElementsByClassName('j-head-sign-in')[0];
        // let siginEvent = new Event('click');
        // siginBtn.dispatchEvent(siginEvent);
        window.parent.triggerSigin();
    }
    joinFreeFn(){
        // let siginBtn = window.parent.document.getElementsByClassName('j-head-joinfree')[0];
        // let siginEvent = new Event('click');
        // siginBtn.dispatchEvent(siginEvent);
        window.parent.triggerJoinFree();
    }
    //购物车产品信息埋点
    trackCartInfo(options){
        try{
            let obj = document.getElementById(options.id);
            obj.setAttribute('event-code', options.eventCode);
            window.__exposureBuryingPoint.init({
                module: obj,
                moduleName: options.spmC,
                spm_b: document.body.getAttribute('spm-b'),
                moduleIndex: '1',
                event_body: {
                    event_type: 'click',
                    event_name: 'click',
                    event_data: {
                        event_entity_info: {
                            link_type:'',
                            other: !!options.other ? JSON.stringify(options.other) : ''
                        }
                    }
                }
            });
            obj.setAttribute('event-code', '');
        }catch(error){}
    }

    render() {
        let { isLogin, totalamountLocal, selectedItemCount, cartList, disableList, cartListLen, disalbedLen, showSkeleton, loading} = this.state;
        let proSpmIndex = 0;

        return (
            <div className='express-cart-wrap'>
                <div className='express-cart-total' spm-c="subtotal">
                    <p className='total-title'>{intl.get('cart_subtotal')}</p>
                    <p className={`total-price ${totalamountLocal.length > 10 && totalamountLocal.length <= 15 ? 'price-size14' : totalamountLocal.length > 15 ? 'price-size12' : ''}`}>{totalamountLocal}</p>
                    <p>
                      {
                        selectedItemCount === 0
                        ?
                        <span className='total-checkout disabled'>{intl.get('cart_button_checkout')} ({selectedItemCount})</span>
                        :
                        <span className='total-checkout' onClick={this.submitCheckOut} spm-index="checkout" event-type="click" event-code="mZ1yMIIcrqAX">{intl.get('cart_button_checkout')} ({selectedItemCount})</span>
                      }
                    </p>
                    <p><span className='total-go-to-cart' onClick={this.goToCart} spm-index="gotocart" event-type="click" event-code="T2OF9T4xQuDj">{intl.get('cart_go_to_cart')}</span></p>
                </div>
                {
                    showSkeleton
                    ?
                    <Skeleton />
                    :
                    (cartList.length === 0 || cartList.length === disalbedLen) && disableList.length === 0
                    ?
                    <div className='express-cart-empty'>
                        <div className='cart-empty-inner'>
                            <p className='empty-txt'>{intl.get('cart_label_empty')}</p>
                            {
                                !isLogin
                                ?
                                <p className='sigin-txt'>
                                    <span onClick={this.siginFn}>{intl.get('cart_sign_in')}</span> / <span onClick={this.joinFreeFn}>{intl.get('cart_join_free')}</span>
                                </p>
                                :
                                <></>
                            }
                        </div>
                    </div>
                    :
                    <div id="expressCartList" className='express-cart-list' spm-c="product">
                        {/* 购物车扩容 埋点曝光用 */}
                        <span id="expansionTrack" ab-version={this.state.expansionABV || ''}></span>

                        {
                            cartList.map((store, storeIndex) => {
                                return(
                                    <React.Fragment key={storeIndex}>
                                    {
                                        store.cartMixList.map((list, listIndex) => {
                                            let mixListLen = list.cartList.length;
                                            let isMix = mixListLen > 1 ? true : false;

                                            return(
                                                <React.Fragment key={listIndex}>
                                                {
                                                    list.cartList.map((proList, proIndex) => {
                                                        let skuName = [], skuInfo = '';
                                                        if( proList.product.productAttrList.length > 0){
                                                            proList.product.productAttrList.forEach((sku)=>{
                                                                if(!!sku.attrValName){
                                                                    skuName.push(sku.attrValName);
                                                                }
                                                            })

                                                            skuInfo = skuName.join(', ');
                                                        }

                                                        if(!proList.isDisabled){
                                                            proSpmIndex +=1;
                                                        }

                                                        return(
                                                            !proList.isDisabled
                                                            ?
                                                            <div key={proList.product?.cartId} className='express-cart-info' itemcode={proList.product?.productBase?.itemcode} cartid={proList.product?.cartId}>
                                                                <div className='cart-img'>
                                                                    <a href={`${React.$site}${proList.product?.productBase?.productUrl}`} target="_blank" title={skuInfo} spm-index={proSpmIndex} event-code="nwMgH77AtQUD" itemcode={proList.product?.productBase?.itemcode}>
                                                                        {
                                                                            !!proList.product?.productBase?.thumbnailImage
                                                                            ?
                                                                            <img data-src={`//www.dhresource.com/${proList.product?.productBase?.thumbnailImage}`} src="" alt="" />
                                                                            :
                                                                            <img src="" alt="" />
                                                                        }
                                                                    </a>
                                                                    <span className={`express-cart-checkbox ${!!proList.isDisabled ? "disabled" : (!!proList.isChecked? "checked" : "")}`} onClick={this.onCheck.bind(this, proList.isDisabled, proList.isChecked, proList.product.cartId, proList.product.productBase.itemcode)} spm-index="select" event-type="click" event-code="SkF1tmCX9WvR"></span>
                                                                </div>
                                                                {
                                                                    skuInfo !== '' && proList.isChecked
                                                                    ?
                                                                    <div className='cart-sku'>{skuInfo}</div>
                                                                    :
                                                                    <></>
                                                                }
                                                                <div className='cart-price'>{proList.cartPrice?.priceLocal}</div>
                                                                <div className='cart-option'>
                                                                    <Quantity itemData={proList} supplierId={store.supplier?.supplierId} isMix={isMix} updateQuantity={this.updateQuantity} onRemove={this.onRemove} />
                                                                    <span className='cart-remove' onClick={this.onRemove.bind(this, proList.isChecked, proList.product.cartId, proList.product.productBase.itemcode, isMix)} spm-index="delete" event-type="click" event-code="qON14LeCPjvw"></span>
                                                                </div>
                                                            </div>
                                                            :
                                                            ''
                                                        )
                                                    })
                                                }
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                    </React.Fragment>
                                )
                            })
                        }
                        {
                            disableList.map((proList, proIndex)=>{
                                let skuName = [], skuInfo = '';
                                if( proList.product.productAttrList.length > 0){
                                    proList.product.productAttrList.forEach((sku)=>{
                                        skuName.push(sku.attrValName);
                                    })

                                    skuInfo = skuName.join(', ');
                                }

                                cartListLen += 1;

                                return(
                                    <div key={proList.product?.cartId} className='express-cart-info' itemcode={proList.product?.productBase?.itemcode} cartid={proList.product?.cartId}>
                                        <div className='cart-img'>
                                            <a href={`${React.$site}${proList.product?.productBase?.productUrl}`} target="_blank" title={skuInfo} spm-index={cartListLen} event-code="nwMgH77AtQUD" itemcode={proList.product?.productBase?.itemcode}>
                                                {
                                                    !!proList.product?.productBase?.thumbnailImage
                                                    ?
                                                    <img data-src={`//www.dhresource.com/${proList.product?.productBase?.thumbnailImage}`} src="" alt="" />
                                                    :
                                                    <img src="" alt="" />
                                                }
                                            </a>
                                        </div>
                                        <div className='cart-price'>{proList.cartPrice?.priceLocal}</div>
                                        <div className='cart-unavailable'>
                                        {
                                            !proList.cartShip?.shipMethod
                                            ?
                                            intl.get('cart_update_shipping')
                                            :
                                            (!!proList.product.productInventory.maxQuantity && proList.product.productInventory.maxQuantity === 0) || !!proList.product.productInventory.noSale
                                            ?
                                            intl.get('cart_sold_out')
                                            :
                                            intl.get('cart_unavailable')
                                        }
                                        </div>
                                        {/* <div className='cart-delete' onClick={this.onRemove.bind(this, proList.isChecked, proList.product.cartId, proList.product.productBase.itemcode, isMix)}><i></i></div> */}
                                        <div className='cart-delete' onClick={this.onSampleRemove.bind(this, proList.product.cartId, proList.isMix)} spm-index="delete" event-type="click" event-code="qON14LeCPjvw"><i></i></div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                <div className="express-cart-loading" style={loading ? { display: "block" } : { display: "none" }}></div>
            </div>
        )
    }
}

export default App
